import React, {useEffect, useState} from "react";
import {Autocomplete, Box, CircularProgress, TextField} from "@mui/material";
import {t} from "i18next";
import {Field, useFormikContext} from "formik";
import {getCountries} from "../../common/api";

export interface Country {
    countryCode: string;
    name: string;
}

export interface CountryInputProps {
    fieldName: string;
    onChange?: any;
}

export default function CountryInputFormik({
                                               fieldName,
                                               onChange
                                           }: CountryInputProps) {
    const formik = useFormikContext<any>()

    const [open, setOpen] = React.useState(false);
    const [options, setOptions] = React.useState<Country[]>([]);
    const loading = open && options.length === 0;
    const [country, setCountry] = useState<Country | null>()

    useEffect(() => {
        if (onChange)
            onChange(formik)
    }, [formik?.values?.[fieldName]]);

    useEffect(() => {
        let active = true;

        if (!loading) {
            return undefined;
        }

        if (active) {
            getCountries().then((response: any) => {
                const countries = response?.data as Country[] ?? []

                setOptions([...countries].sort((a, b) => {
                    if (a.countryCode === 'UA') {
                        return -1;
                    }
                    if (b.countryCode === 'UA') {
                        return 1;
                    }
                    return 0;
                }))
            }).catch((error) => console.log(error))
        }

        return () => {
            active = false;
        };
    }, [loading]);

    useEffect(() => {
        formik.setFieldValue(fieldName, country?.countryCode ?? null)
    }, [country]);

    return <Field
        name={fieldName}
        render={() => <Autocomplete
            id="async-country"
            sx={{
                width: "auto",
            }}
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            isOptionEqualToValue={(option, value) => option.countryCode === value.countryCode}
            getOptionLabel={(option) => option.name}
            options={options}
            loading={loading}
            popupIcon={<Box
                sx={{width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center"}}><img
                src={"https://trtshopping.com/wp-content/uploads/2023/06/dropdown-icon.svg"} alt={''}
                width="12"/></Box>}
            onBlur={() =>
                formik.setFieldTouched(fieldName, true)}
            renderOption={(props, option) => (
                <Box component="li" sx={{'& > img': {mr: 2, flexShrink: 0}}} {...props}>
                    <img
                        loading="lazy"
                        width="30"
                        src={`https://flagcdn.com/w40/${option.countryCode.toLowerCase()}.png`}
                        alt=""
                    />
                    {option.name}
                </Box>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={t('country.placeholder')}
                    error={!!formik.errors[fieldName] && !!formik.touched[fieldName]}
                    InputProps={{
                        ...params.InputProps,
                        disableUnderline: true,
                        startAdornment: <img
                            width="16" src={'https://trtshopping.com/wp-content/uploads/2023/06/Icon.svg'}
                            alt={""} style={{marginRight: '5px'}}/>,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
            value={country ?? null}
            onChange={(_, value) => {
                formik.setFieldTouched(fieldName, true)
                setCountry(value)
            }}
        />}
    />

        ;


}